import { openPersonalizationPopup } from '@/scripts/core/global'

let personalizationBadgeInitialized = false

export function initializePersonalizationBadgeTriggers() {
	if (personalizationBadgeInitialized) return
	personalizationBadgeInitialized = true

	document.addEventListener('click', (event: Event) => {
		const target = event.target as HTMLElement | null
		if (!target) return
		const trigger = target.closest('.trigger-personalization-popup') as HTMLElement | null
		if (!trigger) return
		if(trigger.classList.contains('disabled')) return

		event.preventDefault()

		const productUrl = trigger.getAttribute('data-product-url') || ''
		const variantId = trigger.getAttribute('data-variant-id') || ''
		if (!productUrl || !variantId) return

		openPersonalizationPopup(productUrl, String(variantId))
	})
}


